import React from "react";
import ReactDOM from "react-dom/client";
import { Provider } from "react-redux";
import { BrowserRouter } from "react-router-dom";
import { Amplify } from "aws-amplify";
import { cognitoUserPoolsTokenProvider } from "aws-amplify/auth/cognito";
import { CookieStorage } from "aws-amplify/utils";
import * as serviceWorker from "./serviceWorker";
import store from "./store";
import App from "./App";

Amplify.configure({
  Auth: {
    Cognito: {
      userPoolId: `${process.env.REACT_APP_USER_POOL_ID}`,
      userPoolClientId: `${process.env.REACT_APP_CLIENT_ID}`,
      loginWith: {
        email: true,
        oauth: {
          domain: `${process.env.REACT_APP_COGNITO_DOMAIN}`,
          redirectSignIn: [`${window.location.origin}/auth/code`],
          redirectSignOut: [`${window.location.origin}/auth/login`],
          responseType: "code",
          scopes: ["openid", "email", "profile"],
        },
      },
    },
  },
});

cognitoUserPoolsTokenProvider.setKeyValueStorage(
  new CookieStorage({
    domain: `${process.env.REACT_APP_COOKIE_DOMAIN}`,
    secure: `${process.env.REACT_APP_COOKIE_SECURE}` === "true",
    path: `${process.env.REACT_APP_COOKIE_PATH}` || "/",
    expires: Number(process.env.REACT_APP_COOKIE_EXPIRES || "7"),
  })
);

const root = ReactDOM.createRoot(document.getElementById("root")!);

root.render(
  <React.StrictMode>
    <Provider store={store}>
      <BrowserRouter>
        <App />
      </BrowserRouter>
    </Provider>
  </React.StrictMode>
);

serviceWorker.unregister();
